import React from 'react';

function SearchBar({ search, setSearch, searchMovies }) {
  return (
    <div className="search-box">
      <input
        type="text"
        placeholder="Search for a movie..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && searchMovies()}
      />
      <button onClick={searchMovies}>Search</button>
    </div>
  );
}

export default SearchBar;